import GroupedSearchPage, { GroupedSearchPageProps } from 'components/grouped-search-page/GroupedSearchPage';

const PublicationsPage: React.FC<GroupedSearchPageProps> = props => (
  <GroupedSearchPage {...props} hasLowerCaseSectionFilters />
);

PublicationsPage.displayName = 'PublicationsPage';

export default PublicationsPage;
